<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->

      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
        style="position: relative;"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >

          <div class="text-center">
            <vuexy-logo />
          </div>

          <b-card-title
            title-tag="h2"
            class="font-weight-bold my-1 text-center"
          >
            به شارژ مستر خوش آمدید
          </b-card-title>
          <b-card-text
            v-if="showMobile"
            class="mb-1"
          >
            لطفا شماره تلفن همراه خود را برای دریافت کد یک بار مصرف وارد نمایید.
          </b-card-text>

          <b-card-text
            v-if="!showMobile && !chooseBuilding"
            class="mb-3 text-center"
          >
            لطفا کد ارسال شده از طریق پیامک را وارد نمایید.
          </b-card-text>

          <b-card-text
            v-if="chooseBuilding"
            class="mb-2"
          >
            لطفا ساختمان را انتخاب نمایید.
          </b-card-text>
          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- mobile -->
              <b-form-group
                v-if="showMobile"
                label="تلفن همراه"
                label-for="login-mobile"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Mobile"
                  rules="required|mobile"
                  :custom-messages="{ required: ' ', mobile: 'لطفا موبایل خود را به درستی وارد نمایید' }"
                >
                  <b-form-input
                    id="login-mobile"
                    v-model="userMobile"
                    :state="errors.length > 0 ? false:null"
                    name="login-mobile"
                    placeholder="09123456789"
                    maxlength="11"
                    style="text-align: left; font-weight: 300; letter-spacing: 0.1em; font-size: 120%; direction: ltr; padding-top: 10px;"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->

              <!-- change mobile -->
              <div
                v-if="!showMobile && !chooseBuilding"
                class="mobile-edit"
                @click="showMobile=true"
              >
                کد تایید به شماره {{ userMobile }} ارسال شد
              </div>

              <b-form-group
                v-if="!showMobile && !chooseBuilding"
                label-for="login-otp"
              >
                <validation-provider
                  #default="{ errors }"
                  name="login-otp"
                  rules="required"
                  :custom-messages="{ required: 'لطفا کد تایید را وارد نمایید' }"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-otp"
                      v-model="otp"
                      autofocus
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      name="login-otp"
                      placeholder="12345"
                      maxlength="5"
                      style="text-align: center; font-weight: 300; letter-spacing: 1em; font-size: 150%; direction: ltr; padding-top: 10px;"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <div v-if="!showMobile && !chooseBuilding">
                <!-- ANCHOR privacySigned -->
                <div v-if="!privacySigned">
                  <b-form-group>
                    <b-form-checkbox v-model="privacyChecked">
                      <span style="font-size: 12px;">
                        شرایط استفاده از خدمات و
                        <a
                          href="#"
                          @click="$bvModal.show('modal-privacy')"
                        >
                          حریم&nbsp;خصوصی
                        </a>
                        را می‌پذیرم
                      </span>
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </div>
              <!-- choose building -->
              <b-row v-if="chooseBuilding">
                <b-col
                  v-for="building in buildingList"
                  :key="building.building_id"
                  md="12"
                >
                  <b-button
                    type="submit"
                    variant="outline-secondary"
                    block
                    class="mb-1 text-left"
                    @click="submitForm(building.building_id)"
                  >

                    <h5>{{ building.name }}</h5>

                    <small
                      style="display: block;"
                      class="mt-1"
                    >
                      {{ building.address }}
                    </small>
                  </b-button>
                </b-col>
              </b-row>

              <!-- submit buttons -->
              <b-button
                v-if="showMobile"
                type="submit"
                variant="primary"
                block
                @click="sendOTP"
              >
                دریافت کد
              </b-button>
              <!--b-button
                v-if="showMobile"
                variant="primary"
                block
                class="btn-icon btn btn-danger"
                @click="viewDemo"
              >
                اکانت دمو
              </!--b-button-->
              <b-button
                v-if="!showMobile && !chooseBuilding"
                type="submit"
                variant="primary"
                block
                :disabled="!privacyChecked"
                @click="submitForm()"
              >
                ورود
              </b-button>
            </b-form>
          </validation-observer>

          <li class="privacy-link">
            <a
              href="#"
              @click="$bvModal.show('modal-privacy')"
            >
              حریم&nbsp;خصوصی
            </a>
          </li>
        </b-col>
      </b-col>
      <!-- /Login-->

    </b-row>
    <b-modal
      id="modal-privacy"
      hide-footer
      hide-header-close
      centered
      title="سیاست حریم خصوصی"
    >
      <privacy />
      <b-button
        class="d-block mx-auto mt-2 px-3"
        size="md"
        variant="primary"
        @click="$bvModal.hide(`modal-privacy`)"
      >
        بستن
      </b-button>
    </b-modal>
  </div>
</template>

<script>
// SECTION - JS
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BModal,
} from 'bootstrap-vue'
import { required, mobile } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@/libs/axios'
import authService from '@/api/authService'
import Privacy from './Privacy.vue'

// ANCHOR - components
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BModal,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    Privacy,
  },
  mixins: [togglePasswordVisibility],
  // ANCHOR data
  data() {
    return {
      privacySigned: false,
      privacyChecked: false,
      showMobile: true,
      status: '',
      otp: '',
      userMobile: '',
      buildingList: null,
      selectedBuilding: null,
      chooseBuilding: false,
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rules import store from '@/store/index'
      required,
      mobile,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    viewDemo() {
      authService.demo()
        .then(response => {
          localStorage.setItem('token', response.data.token)
          this.$router.push({ path: '/' })
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
        })
    },
    sendOTP() {
      this.loading = true
      authService.login({
        mobile: this.userMobile,
      })
        .then(response => {
          this.loading = false
          this.$refs.loginValidation.validate()
            .then(success => {
              if (success) {
                this.privacySigned = response.data.privacy_signed
                this.privacyChecked = response.data.privacy_signed
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'کد ارسال شد',
                    icon: 'EditIcon',
                    variant: 'success',
                  },
                })
                this.showMobile = false
              }
            })
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    async submitForm(buildingId) {
      const data = {
        mobile: this.userMobile,
        code: this.otp,
        building_id: buildingId || null,
      }
      let response = {}
      if (buildingId) {
        response = await authService.selectBuilding(data)
      } else {
        response = await authService.verify(data)
      }

      localStorage.setItem('token', response.data.token)
      if (response?.data?.building_list?.length) {
        this.chooseBuilding = true
        this.buildingList = response.data.building_list
      } else if (response.data.redirect) {
        const map = {
          home: '/',
        }
        this.$router.push({ path: map[response.data.redirect] ?? response.data.redirect })
      } else {
        this.$router.push({ path: '/' })
      }
    },
  },

}
// !SECTION
</script>

<style lang="scss">
// SECTION CSS
@import '@core/scss/vue/pages/page-auth.scss';

.btn-demo {
  width: 100px;
  bottom: 30px;
  position: absolute;
  right: 70px;
  //.btn {
  box-shadow: 0 1px 20px 1px $danger !important;

  &:hover {
    box-shadow: none !important;
  }

  //}
}

[dir="rtl"] .modal#modal-privacy {
  padding: 0 !important;

  .modal-header .close {
    transform: translate(-2px, -2px);
  }
}
//.btn-scroll-to-top {
//  position: fixed;
//  bottom: 5%;
//  right: 30px;
//  z-index: 99;
//
//  opacity: 0;
//  // transform: translateY(100px);
//  transition: all .5s ease;
//
//  &.show {
//    opacity: 1;
//    // transform: translateY(0)
//  }
//}
.mobile-edit {
  margin: 4px 0;
  font-size: 12px;
  cursor: pointer;
  color: #7367f0;
}

.brand-name {
  font-size: 24px;
  font-weight: 900;
}

.logo {
  display: flex;
  @media only screen and (max-width: 991px) {
    justify-content: center;
  }
}

.privacy-link {
  margin: 4rem 1rem;
}
// !SECTION
</style>
